<div id="topStepper" class="static w-full max-w-screen-xl mx-auto md:py-8 md:px-6 sm:p-0 bg-card ">
  <!-- Main -->
  <div class="flex-auto overflow-y-auto" cdkScrollable>

  <div class="mx-auto rounded-full px-8 py-2 md:hidden" >

    <span class="ml-5">Passaggio {{currentStep + 1}} di {{totalSteps}}</span>

    <mat-progress-bar [value]="(100 * (currentStep + 1)) / totalSteps"
    ></mat-progress-bar>
  </div>

    <mat-stepper linear="linear" [selectedIndex]="currentStep" #stepper>

      <mat-step *ngFor="let step of field.fieldGroup; let index = index; let last = last"
        [completed]="isValid(step) && !model.is_new" [errorMessage]="'Verifica i dati compilati'" [editable]="true">

        <ng-template matStepLabel>
          <span [ngStyle]="{'color': (model.is_new || isValid(step)) ? 'black' : 'red'}">{{ step.props.slabel ||
            step.props.label }}</span>
        </ng-template>

        <div class="place-content-center">
          <formly-field [field]="step"></formly-field>
        </div>

        <div class="flex justify-between">

          <button *ngIf="(index!=0 && model.stato_id=='compilazione')" mat-flat-button matStepperPrevious
            class="px-4 mr-2" [color]="'primary'" type="button" [disabled]="model.is_new" (click)="goToPreviousStep()"
            aria-labelledby="Precedente">
            Indietro
          </button>

          <button *ngIf="model.stato_id=='compilazione' && index!=0" class="items-center px-4 mr-2" mat-flat-button
            [color]="'primary'" type="button" [disabled]="model.is_new" (click)="updateIstanza(index,false)"
            aria-labelledby="Salva">
            Salva
          </button>

          <button matStepperNext
            *ngIf="false && model.stato_id=='compilazione' && !(index !== field.fieldGroup.length - 2)"
            class="items-center px-4 mr-2" mat-flat-button [color]="'primary'" type="button"
            [disabled]="model.is_new || isLastButtonStepDisabled()"
            [ngClass]="{'bg-red-600 text-on-primary': !isValid(step)}" (click)="terminaCompilazione()"
            matTooltip="Per continuare è necessario completare i campi richiesti" aria-labelledby="Vai al riepilogo">
            Vai al riepilogo
          </button>

          <button matStepperNext
            *ngIf="model.stato_id=='compilazione' && !(last || model.is_new || index == field.fieldGroup.length - 1)"
            class="items-center px-4 mr-2" mat-flat-button [color]="'primary'" type="button" [disabled]="model.is_new"
            [ngClass]="{'bg-red-600 text-on-primary': !isValid(step)}" (click)="goToNextStep(false);"
            matTooltip="Per continuare è necessario completare i campi richiesti" aria-labelledby="Successivo">
            Avanti
          </button>

          <button *ngIf="model.is_new" [disabled]="!isValid(step)" class="items-center px-4 mr-2" mat-flat-button
            [color]="'primary'" type="button" (click)="updateIstanza(true, 1)" aria-labelledby="Inizia la compilazione">
            Avanti
          </button>

          <button *ngIf="model.stato_id=='riepilogo' && !user.is_superuser" mat-flat-button matStepperPrevious
            class="px-4 mr-2" [color]="'primary'" type="button" (click)="tornaCompilazione(currentStep)"
            aria-labelledby="Torna in compilazione">
            Torna in compilazione
          </button>

          <button
            *ngIf="(model.stato_id=='riepilogo' || model.stato_id=='pagamento-presentazione') && user.is_superuser"
            mat-flat-button matStepperPrevious class="px-4 mr-2" [color]="'primary'" type="button"
            (click)="tornaCompilazione(currentStep)" aria-labelledby="Torna in compilazione">
            Torna in compilazione (ADMIN)
          </button>

          <button *ngIf="last && model.stato_id=='compilazione'" mat-flat-button class="items-center px-4 mr-2"
            [color]="'primary'" [disabled]="!isValid(field) || buttonClicked" (click)="terminaCompilazione()"
            type="button" aria-labelledby="Vai al riepilogo">
            Vai al riepilogo
          </button>


        <ng-container *ngIf="pagamenti$ | async as pagamenti">
          <button *ngIf="last && model.stato_id=='riepilogo' && pagamenti.length==0" mat-flat-button
            class="items-center px-4 mr-2" [color]="'primary'" [disabled]="!isValid(step)" (click)="inoltraIstanza()"
            type="button" aria-labelledby="Inoltra istanza">
            Inoltra l'istanza
          </button>

          <button *ngIf="last && model.stato_id=='riepilogo' && pagamenti.length!=0" mat-flat-button
            class="items-center px-4 mr-2" [color]="'primary'" [disabled]="!isValid(step)" (click)="alPagamento()"
            type="button" aria-labelledby="Vai al pagamento">
            Vai al pagamento
          </button>
        </ng-container>


        </div>

      </mat-step>

      <mat-step *ngIf="model.stato_id=='compilazione'" label="RIEPILOGO" state="riepilogo" [disabled]="true"
        [completed]="model.stato_id=='riepilogo'">


        <div class="flex flex-row justify-start items-center gap-x-4">
          <mat-spinner></mat-spinner>
          <div class="text-lg text-secondary">CREAZIONE DEL RIEPILOGO IN CORSO</div>
        </div>
      </mat-step>

      <mat-step *ngIf="pagopaStep" label="PAGAMENTO" state="pagamento" [disabled]="true"
        [completed]="model.stato_id=='pagamento-presentazione'"></mat-step>


      <!-- Default / Active State -->
      <ng-template matStepperIcon="number" let-index="index">
        <mat-icon *ngIf="isValidCheck(field.fieldGroup[index])">done</mat-icon>
        <mat-icon *ngIf="!isValidCheck(field.fieldGroup[index])">close</mat-icon>
      </ng-template>


        <ng-template matStepperIcon="riepilogo" let-index="index">
          <mat-icon *ngIf="isValidCheck(field.fieldGroup[index])">done</mat-icon>
          <mat-icon *ngIf="!isValidCheck(field.fieldGroup[index])">close</mat-icon>
        </ng-template>

      <ng-template matStepperIcon="pagamento">
        <mat-icon>close</mat-icon>
      </ng-template>

    </mat-stepper>

  </div>

</div>
